import { z } from "zod";
/**
 * Base ChatMessage schema and ChatMessageSenderType enum
 * Used by message-related endpoints
 */
export const ForgeChatMessageSenderType = z.enum([
    "User",
    "Agent",
    "Developer",
    "FunctionCallInput",
    "FunctionCallOutput",
]);
export const ForgeChatMessageSender = z.discriminatedUnion("type", [
    z.object({
        type: z.literal(ForgeChatMessageSenderType.Values.User),
        userId: z.string(),
    }),
    z.object({
        type: z.literal(ForgeChatMessageSenderType.Values.Agent),
        persona: z.literal("Amy"),
    }),
    z.object({ type: z.literal(ForgeChatMessageSenderType.Values.Developer) }),
    z.object({
        type: z.literal(ForgeChatMessageSenderType.Values.FunctionCallInput),
    }),
    z.object({
        type: z.literal(ForgeChatMessageSenderType.Values.FunctionCallOutput),
    }),
]);
export const ForgeChatMessageUserScoreType = z.enum(["Positive", "Negative"]);
export const ForgeChatMessageUserScore = z.object({
    type: ForgeChatMessageUserScoreType,
    tags: z.string().array(),
    comment: z.string().optional(),
});
export const ForgeChatMessage = z.object({
    id: z.string(),
    threadId: z.string(),
    payload: z.string(),
    createdAt: z.coerce.date(),
    updatedAt: z.coerce.date(),
    opikTraceId: z.string().optional(),
    sender: ForgeChatMessageSender,
    userScore: ForgeChatMessageUserScore.optional(),
});
